<template>
  <div class="klickbox-step-title">
    <div class="klickbox-edit-title">
      {{ $t('general.labels.title') }}
    </div>
    <text-editor
      :content="step.title"
      :change="onChange"
      :placeholder="$t('edit.canvas.question_title_placeholder')"></text-editor>
    <span class="klickbox-step-bar"></span>
  </div>
</template>

<script>
import TextEditor from 'src/components/general/TextEditor/Main';

export default {
  components: {
    TextEditor,
  },
  props: [
    'step',
  ],
  methods: {
    onChange(text) {
      this.$store.dispatch('stepUpdateTitle', {
        event: { target: { value: text } },
        id: this.step.id,
      });
    },
  },
};
</script>



/** WEBPACK FOOTER **
 ** Title.vue?672bfbe0
 **/